import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
import externalLinkFill from "@iconify/icons-eva/external-link-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Card,
  CardContent,
  Chip
} from "@mui/material";
// components
import { MHidden } from "../../components/@material-extend";
//
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import LanguagePopover from "./LanguagePopover";
import NotificationsPopover from "./NotificationsPopover";
import { getPageInstructionApi } from "src/api/commonapi";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

const InfoCard = styled(Card)(({ theme }) => ({
  marginTop: "10px",
  background: "#1c4766",
  backdropFilter: "blur(10px)",
  border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
  borderRadius: theme.spacing(1.5),
  boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.1)}`,
  transition: "all 0.3s ease"
  // "&:hover": {
  //   transform: "translateY(-2px)",
  //   boxShadow: `0 8px 30px ${alpha(theme.palette.primary.main, 0.15)}`
  // }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  textTransform: "none",
  fontWeight: 600,
  padding: theme.spacing(0.5, 2),
  minHeight: 32,
  fontSize: "0.875rem",
  background: "#ffffff",
  color: theme.palette.primary.main,
  boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
  "&:hover": {
    background: "#ffffff",
    color: theme.palette.primary.main,
    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
  }
  // "&:active": {
  //   transform: "translateY(0px)"
  // }
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const user = JSON.parse(localStorage.getItem("userData"));
  const [routeData, setRouteData] = useState([]);
  const location = useLocation();
  const currentPath = location.pathname.replace("/", "");

  const getPageInstruction = async () => {
    try {
      const response = await getPageInstructionApi();
      let data = response?.data;

      // Ensure data is an array
      if (Array.isArray(data)) {
        setRouteData(data);
      } else {
        setRouteData([]);
      }
    } catch (error) {
      console.error("Error fetching page instruction:", error);
      setRouteData([]);
    }
  };

  const currentPage = Array.isArray(routeData)
    ? routeData.find((item) => item.page_route === currentPath)
    : null;
  const currentDescription = currentPage ? currentPage?.page_des || "" : "";
  const buttonName = currentPage ? currentPage?.btn_title || "" : "";
  const buttonUrl = currentPage ? currentPage?.button_url || "" : "";

  useEffect(() => {
    getPageInstruction();
  }, []);

  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: "text.primary" }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        {/* Page Info Card */}
        {currentDescription && (
          <Box sx={{ flexGrow: 1, mr: 3 }}>
            <InfoCard elevation={0}>
              <CardContent sx={{ p: 1.5, "&:last-child": { pb: 1.5 } }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Typography
                    variant="body2"
                    title={currentDescription}
                    sx={{
                      color: "#ffffff",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      lineHeight: 1.4,
                      fontSize: "0.875rem",
                      flex: 1
                    }}
                  >
                    {currentDescription}
                  </Typography>

                  {buttonName && buttonUrl && (
                    <StyledButton
                      variant="contained"
                      size="small"
                      href={buttonUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      endIcon={<Icon icon={externalLinkFill} width={14} height={14} />}
                    >
                      {buttonName}
                    </StyledButton>
                  )}
                </Stack>
              </CardContent>
            </InfoCard>
          </Box>
        )}

        <Box sx={{ flexGrow: currentDescription ? 0 : 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          <span style={{ color: "#000" }}>{user?.name}</span>
          {/* <LanguagePopover /> */}
          {/* <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
